import React,  { Suspense, useEffect, useRef } from 'react'
import { Router, BrowserRouter, useNavigationType, useLocation, useSearchParams, unstable_HistoryRouter as HistoryRouter, Link, Outlet, Routes, Route } from 'react-router-dom'
import { CSSTransition, TransitionGroup, SwitchTransition } from 'react-transition-group'
import 'antd-mobile/es/global'
import routes from './routers'
import { RenderRouter } from './routers/renderRoutes'
import { history } from '@/util';
// 样式
// react-vant按需加载但是还是需要引入样式
// import 'react-vant/lib/index.css'
// antd-mobile-v5按需加载但是还是需要引入全局逻辑和样式
import './App.scss'
import i18n from '@/local';

// home
import MyIndex from '@/pages/my/index';
import Home from '@/pages/home/index';

const ANIMATION_MAP = {
  PUSH: 'forward',
  POP: 'back',
}


const TransitionRoutes = () => {
  const location = useLocation()
  const navigate = useNavigationType()
  const nodeRef = useRef(null);
  const [searchParams] = useSearchParams()

  const logout = () => {
    userLogOut()
  }

  useEffect(()=>{

  },[])

  useEffect(()=>{
  },[location.pathname])

  useEffect(()=>{
    const kol_id = searchParams.get('kol_id')
    twq('event', 'tw-onhhj-onhhl', {
        value: `kol_id:${kol_id}`
      });
  },[])

  // app_start

  // i18n.changeLanguage('en')
  return (
    <SwitchTransition
      className={'router-wrapper'}
      // childFactory={(child) =>
      //   React.cloneElement(child, {
      //     classNames: ANIMATION_MAP[navigate],
      //   })
      // }
      // appear={false}
    >
      <CSSTransition
        onEnter={()=>{
          scrollTo(0,0)
        }}
        timeout={{
          enter: 500,
		      exit: 300,
        }}
        // ref={nodeRef}
        nodeRef={nodeRef}
        classNames={ANIMATION_MAP[navigate]}
        key={location.pathname}
        unmountOnExit
      >
        <div className={'box'} ref={nodeRef} >
          <RenderRouter routes={routes} location={location} />
        </div>
      </CSSTransition>
    </SwitchTransition>
  )
}

function App () {

  // i18n.changeLanguage('ja')
  return (
      <Suspense fallback={null}>
        <HistoryRouter history={history}>
          <TransitionRoutes />
        </HistoryRouter>
      </Suspense>
  )
}

export default App
